import { useEffect, useState } from "react";
import api from "@/lib/api";

/**
 * "Follow on Google News" pill. Free — no API/embed script.
 * Backend can supply a publication_url once the site is verified in
 * Google Publisher Center; until then the button links to a search that
 * users can bookmark.
 */
const DEFAULT_URL = "https://news.google.com/search?q=denvapost";

export default function GoogleFollow({ variant = "footer" }) {
  const [cfg, setCfg] = useState({ enabled: true, publication_url: "" });

  useEffect(() => {
    api.get("/public/settings")
      .then((r) => setCfg(r.data?.google_follow || { enabled: true, publication_url: "" }))
      .catch(() => {});
  }, []);

  if (!cfg.enabled) return null;
  const href = cfg.publication_url && cfg.publication_url.trim() ? cfg.publication_url.trim() : DEFAULT_URL;

  const base =
    variant === "compact"
      ? "inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full border border-[#0F0F0F]/25 text-[11px] font-semibold uppercase tracking-[0.14em] hover:border-[#D92525] hover:text-[#D92525] transition-colors"
      : "inline-flex items-center gap-2 px-3.5 py-2 rounded-full border border-white/30 text-[12px] font-semibold uppercase tracking-[0.14em] text-white/85 hover:border-[#D92525] hover:text-[#D92525] transition-colors";

  return (
    <a
      href={href}
      target="_blank"
      rel="noreferrer"
      data-testid={`google-follow-${variant}`}
      className={base}
      title="Follow Denva Post on Google News"
    >
      {/* Simple Google 'G' mark rendered inline (no external asset) */}
      <svg width="14" height="14" viewBox="0 0 24 24" aria-hidden="true" style={{ display: "inline-block", verticalAlign: "middle" }}>
        <path fill="#4285F4" d="M23.5 12.3c0-.8-.1-1.6-.2-2.3H12v4.5h6.5c-.3 1.5-1.1 2.7-2.4 3.6v3h3.9c2.3-2.1 3.5-5.2 3.5-8.8z"/>
        <path fill="#34A853" d="M12 24c3.2 0 5.9-1.1 7.9-2.9l-3.9-3c-1.1.7-2.5 1.2-4 1.2-3.1 0-5.7-2.1-6.6-4.9H1.4v3.1C3.4 21.4 7.4 24 12 24z"/>
        <path fill="#FBBC05" d="M5.4 14.4c-.2-.7-.4-1.4-.4-2.4s.1-1.7.4-2.4V6.5H1.4C.5 8.2 0 10 0 12s.5 3.8 1.4 5.5l4-3.1z"/>
        <path fill="#EA4335" d="M12 4.8c1.8 0 3.4.6 4.6 1.8l3.5-3.5C17.9 1.2 15.2 0 12 0 7.4 0 3.4 2.6 1.4 6.5l4 3.1C6.3 6.8 8.9 4.8 12 4.8z"/>
      </svg>
      Follow on Google News
    </a>
  );
}
